module.exports = __webpack_public_path__ + "img/play-icon.1ba6f6dd.png";